import React, { useRef, useEffect } from 'react';
import { Check } from 'lucide-react';

export default function InspectionStepper({
  steps,
  activeStep,
  onSelectStep,
  completedSteps = {},
}) {
  const activePillRef = useRef(null);

  // Auto-scroll active step into view on mobile/horizontal scroll
  useEffect(() => {
    if (activePillRef.current && typeof activePillRef.current.scrollIntoView === 'function') {
      activePillRef.current.scrollIntoView({
        behavior: 'smooth',
        inline: 'center',
        block: 'nearest',
      });
    }
  }, [activeStep]);

  return (
    <div className="v2-stepper" role="tablist" aria-label="Pasos del peritaje">
      {steps.map((step, index) => {
        const isActive = activeStep === index;
        const isCompleted = !!completedSteps[index];

        return (
          <div
            key={step.id || index}
            ref={isActive ? activePillRef : null}
            role="tab"
            aria-selected={isActive}
            className={`v2-step-pill ${isActive ? 'active' : ''} ${isCompleted ? 'completed' : ''}`}
            onClick={() => onSelectStep(index)}
            title={step.title}
          >
            <span className="v2-step-num">
              {isCompleted && !isActive ? <Check size={12} strokeWidth={3} /> : index + 1}
            </span>
            <span>{step.title}</span>
            {step.count !== undefined && step.count > 0 && (
              <span
                style={{
                  fontSize: '0.68rem',
                  padding: '1px 6px',
                  borderRadius: 9999,
                  background: isActive ? 'rgba(255, 255, 255, 0.2)' : 'rgba(0, 0, 0, 0.06)',
                  fontWeight: 700,
                }}
              >
                {step.count}
              </span>
            )}
          </div>
        );
      })}
    </div>
  );
}
